import { h } from 'preact';
import * as jsonPointer from 'utils/jsonPointer';
import slugify from 'utils/slugify';

import MovieInfoEditor from 'components/editor/movies/movieInfo/movieInfo';

export default class UniversalMovieInfoEditor extends MovieInfoEditor {

	slugMatchesTitle() {
		if (super.slugMatchesTitle()) return true;

		// If the current slug matches the base movie title, we also consider it a match
		const baseAsSlug = slugify(jsonPointer.get(this.props.data, `/base_movie/content/title`), { removeDiacritics: true });
		const currentSlug = jsonPointer.get(this.props.data, `/content/slug`);
		return currentSlug === baseAsSlug;
	}

	renderTitle() {
		return super.renderTitle({
			inheritPath: `${this.basePath}/base_movie/content/title`,
			alsoSet: [{
				path: `${this.basePath}/content/slug`,
				method: (text) => {
					// If the title is empty, use the base movie title to generate the slug
					text ||= jsonPointer.get(this.props.data, `/base_movie/content/title`) || '';
					return slugify(text, { removeDiacritics: true });
				},
				condition: this.slugMatchesTitle
			}],
		});
	}

	renderExternalUrl() {
		return super.renderExternalUrl({
			help: 'Sets a redirect to the specified URL. Used for movies that are hosted on a vanity URL.'
		});
	}

	renderShowtimesSource() {
		// const baseData = jsonPointer.get(this.props.data, `/base_movie/content/showtimesId`);
		return super.renderShowtimesSource({
			inheritPath: `${this.basePath}/base_movie/content/showtimesId`,
			// defaultValue: baseData,
		});
	}

	renderMagicGenre(opts = {}) {
		const hasBaseMovie = jsonPointer.has(this.props.data, `/base_movie`);
		const baseData = jsonPointer.get(this.props.data, `/base_movie/content/dataLayer/magicGenre`);

		return super.renderMagicGenre({
			inheritPath: `${this.basePath}/base_movie/content/dataLayer/magicGenre`,
			tooltipInherit: `Inherited from Global Settings.`,
			defaultValue: baseData,
			disabled: hasBaseMovie,
			...opts,
		});
	}

	renderEssenceGenre(opts = {}) {
		const hasBaseMovie = jsonPointer.has(this.props.data, `/base_movie`);
		const baseData = jsonPointer.get(this.props.data, `/base_movie/content/dataLayer/essenceGenre`);

		return super.renderEssenceGenre({
			inheritPath: `${this.basePath}/base_movie/content/dataLayer/essenceGenre`,
			tooltipInherit: `Inherited from Global Settings.`,
			defaultValue: baseData,
			disabled: hasBaseMovie,
			...opts,
		});
	}

	renderIMDBId(opts = {}) {
		const hasBaseMovie = jsonPointer.has(this.props.data, `/base_movie`);
		const baseData = jsonPointer.get(this.props.data, `/base_movie/content/dataLayer/imdbId`);

		return super.renderIMDBId({
			inheritPath: `${this.basePath}/base_movie/content/dataLayer/imdbId`,
			tooltipInherit: `Inherited from Global Settings.`,
			defaultValue: baseData,
			disabled: hasBaseMovie,
			...opts,
		});
	}

	renderFieldsPlaceholder() {
		return [
			this.renderTitle(),
			this.renderReleaseDate(),
			this.renderSlug(),
		];
	}

	renderFieldsMoviePlatform() {
		return [
			this.renderTitle(),
			this.renderReleaseDate(),
			this.renderTicketingDate(),
			this.renderHomeEntDate(),
			this.renderReleaseMessaging(),
			this.renderHideFromCarousels(),
			this.renderSlug(),
			this.renderExternalUrl(),
			this.renderShowtimesSource(),
		];
	}

	renderDataLayerSectionHeader() {
		return (
			<div class={this.s.header}>
				<h3>dataLayer Settings</h3>
				<div class={this.s.description}>
					<span>These fields are used for additional tagging and Essence tracking. They can be populated and edited in Global Settings, requires Global Settings access.</span>
				</div>
			</div>
		);
	}

	renderActionsPlaceholder() {
		return [
			this.renderDeletePlaceholder(),
		];
	}

	renderDescription() {
		const isPlaceholder = this.movie.placeholder;
		return [
			'Controls info related to the movie.',
			isPlaceholder && 'Changes here will be reflected on the upcoming movies page on the hubsite.',
			!isPlaceholder && 'Changes here will be reflected on both the hubsite and movie pages, unless overridden in the page editor.'
		].filter(Boolean).map(str => <p>{str}</p>);
	}
}